<template>
  <div class="page-title">
    <b-container>
      <b-row v-if="adsHeader">
        <div class="top-banner">
          <a
            :href="adsHeader.website"
            target="_blank"
            v-if="!adsHeader.advertisment_location.google_on"
            id="imageHeader"
            @click="CLICK_BANNERADS(adsHeader.id)"
          >
            <b-img
              :src="adsHeader.image"
              class="img-card"
              style="max-width: 100%; height: auto"
              :alt="
                adsFooter.website
                  ? adsFooter.website
                  : $t('altTag', {
                      affiliate: $root.affiliate,
                    })
              "
            ></b-img>
          </a>

          <!-- Header -->
          <!-- <Adsense
            data-ad-test="false"
            v-else
            :in-style="isMobile?'display:inline-block;width:300px;height:100px':'display:inline-block;width:970px;height:90px'"
            data-ad-client="ca-pub-6971330106189470"
            :data-ad-slot="isMobile?'5090767974':'9550384591'" 
            :data-full-width-responsive="isMobile?'false':'true'" 
            data-ad-format="horizontal"
          >
          </Adsense> -->
        </div>
      </b-row>
      <b-row>
        <b-col cols="12">
         
          <div class="topbar">
            <b-row class="w-100" no-gutters>
              <b-col cols="auto" class="py-2" :class="isMobile?'px-2':'px-4'">
                <a :href="projectConfig.classifieds_url" style="color: white" :class="!projectConfig.classifieds_url?'active-website':''">
                  {{$t('Classified')}}
                </a>
              </b-col>
              <b-col cols="auto" class="py-2" :class="isMobile?'px-2':'px-4'" >
                <a
                  id="listingDetail"
                  :href="projectConfig.property_url"
                  style="color: white"
                  :class="!projectConfig.property_url?'active-website':''"
                  >{{$t('Property')}}
                </a>
              </b-col>
              <div  class="mx-auto"></div>
              <b-col cols="4" md="9"  class="text-right" :class="isMobile?'px-2':'px-4'">
                <b-dropdown class="menu-user-dropdown userMenuDrop languageDropDown" no-flip v-if="!isMobile">
                  <template v-slot:button-content>
                    <span class="span-element" >
                      <span class="lang-icon" :style="{backgroundImage: `url(/images/${selectedLanguage}.png)`}" v-if="!isMobile"></span>
                      <span style="margin-left:10px">
                      
                        {{selectedLanguage==='th'?$t('Thai'):$t('English')}}
                      </span>
                      
                      <ChevronDownIcon />
                    </span>
                  </template>
                  <b-dropdown-item
                    @click="changeLangugae('th')"
                  >
                  <span class="lang-icon" style="background-image: url('/images/th.png');" v-if="!isMobile"></span>{{$t('Thai')}}
                  </b-dropdown-item>
                  <b-dropdown-item
                  @click="changeLangugae('en')"
                  >
                  <span class="lang-icon" style="background-image: url('/images/en.png');" v-if="!isMobile"></span>
                    {{$t('English')}}
                  </b-dropdown-item>
                </b-dropdown>
                <b-row align-content="end" align-v="end" align-h="end" no-gutters v-if="isMobile">
                  <b-col cols="auto" class="text-right mobile-language-drop-down">
                    <b-dropdown toggle-class="text-decoration-none" no-caret variant="link"  offset="-100" size="sm">
                      <template #button-content>
                        <div class="lang-icon" 
                        :style="{ backgroundImage: 'url(/images/' + selectedLanguage + '.png)' }"
                         ></div>
                      </template>
                      <b-dropdown-item-btn @click="changeLangugae('th')"><div class="lang-icon" style="background-image: url('/images/th.png');float: left;margin-right: 12px;" ></div>{{$t('Thai')}}</b-dropdown-item-btn>
                      <b-dropdown-item-btn @click="changeLangugae('en')"><div class="lang-icon" style="background-image: url('/images/en.png');float: left;margin-right: 12px;" ></div> {{$t('English')}}</b-dropdown-item-btn>
                    </b-dropdown>
                  </b-col>
                  <!-- <b-col cols="auto" class="py-2 px-2 text-right">
                    <div class="lang-icon" style="background-image: url('/images/th.png');" @click="changeLangugae('th')"></div>
                  </b-col>
                  <b-col cols="auto" class="py-2 px-2 text-right">
                    <div class="lang-icon" style="background-image: url('/images/en.png');" @click="changeLangugae('en')"></div>
                  </b-col> -->
                </b-row>
              </b-col>
            </b-row>
            
            
            
          </div>
        </b-col>
        <b-col cols="12" class="flex-wrap-title">
          <router-link
            id="listingDetail"
            :to="$i18nRoute({ name: '' })"
            style="color: white; width: 100%"
          >
            <h1 class="title-page">
              <span class="title">
                <!-- {{$root.siteTitle?$root.siteTitle: $t("buySell") }} -->
                {{ $root.siteTitle }}
              </span>
              
            </h1>
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";
import ChevronDownIcon from "vue-material-design-icons/ChevronDown.vue";
import { Trans } from "@/plugins/Translation";
export default {
  components: {
    ChevronDownIcon,
  },
  data: () => {
    return {
      adsHeader: {
        website: "#",
        image: "",
        advertisment_location: {
          google_on: false,
        },
      },
      siteComing: "property",
      selectedLanguage: "th",
    };
  },
  props: {
    categoryId: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.selectedLanguage = Trans.currentLanguage;
    let locationId = 1;
    if (
      (this.$router.history.current.path == "/th/search/" ||
        this.$router.history.current.path == "/en/search/") &&
      ((this.dataSearch && this.dataSearch.id == 1) || this.categoryId == 1)
    ) {
      locationId = 10;
    }
    if (
      this.$router.history.current.name == "ListingDetail" &&
      ((this.dataSearch && this.dataSearch.id == 1) || this.categoryId == 1)
    ) {
      locationId = 15;
    }
    if (
      (this.$router.history.current.path == "/th/search/" ||
        this.$router.history.current.path == "/en/search/") &&
      ((this.dataSearch && this.dataSearch.id == 2) || this.categoryId == 2)
    ) {
      locationId = 19;
    }
    if (
      this.$router.history.current.name == "ListingDetail" &&
      ((this.dataSearch && this.dataSearch.id == 2) || this.categoryId == 2)
    ) {
      locationId = 24;
    }

    if (
      (this.$router.history.current.path == "/th/search/" ||
        this.$router.history.current.path == "/en/search/") &&
      ((this.dataSearch && this.dataSearch.id == 3) || this.categoryId == 3)
    ) {
      locationId = 28;
    }
    if (
      this.$router.history.current.name == "ListingDetail" &&
      ((this.dataSearch && this.dataSearch.id == 3) || this.categoryId == 3)
    ) {
      locationId = 33;
    }
    if (
      (this.$router.history.current.path == "/th/search/" ||
        this.$router.history.current.path == "/en/search/") &&
      ((this.dataSearch && this.dataSearch.id == 4) || this.categoryId == 4)
    ) {
      locationId = 37;
    }
    if (
      this.$router.history.current.name == "ListingDetail" &&
      ((this.dataSearch && this.dataSearch.id == 4) || this.categoryId == 4)
    ) {
      locationId = 42;
    }

    this.GETADS_FOR_PUBLIC_WEBSITE({
      id: locationId,
    }).then((result) => {
      if (result.data) {
        this.adsHeader = result.data;
      }
    });
    // setTimeout(function(){(adsbygoogle = window.adsbygoogle || []).push({})}, 1000);
  },
  mounted() {},
  computed: {
    ...mapGetters("CategoryController", ["dataSearch"]),
    ...mapGetters("UserController", ["isMobile"]),
    ...mapGetters('SiteConfigController', ['projectConfig']),
  },
  methods: {
    ...mapActions("AdsController", [
      "GETADS_FOR_PUBLIC_WEBSITE",
      "CLICK_BANNERADS",
    ]),
    changeLangugae(lang) {
      this.selectedLanguage = lang;
      Trans.changeLanguage(this.selectedLanguage);
      let url = lang + this.$route.matched[0].path.match(/(?:\/)([^/]+)(?=#*)/g)[1]
      let obj=''
      if(Object.keys(this.$route.query).length && (this.$route.name!== "ListingDetail"||this.$route.name!== "SellerDetail"||this.$route.name!== "EditListing"||this.$route.name!== "Payment"||this.$route.name!== "SpecialDeals"||this.$route.name!== "UserPackageScreen")){
       obj= Object.keys(this.$route.query).map(key => key + '=' + this.$route.query[key]).join('&');
       url=`${url}${obj?'?'+obj:'/'}`
      }else if(this.$route.name=== "ListingDetail"||this.$route.name=== "SellerDetail"||this.$route.name=== "EditListing"||this.$route.name=== "Payment"||this.$route.name=== "SpecialDeals"||this.$route.name=== "UserPackageScreen"){
        url=url.replace(':id',this.$route.params.id)
      }
      if(this.$route.name=== "Home"){
        window.location.href=window.location.origin+'/'+lang
      }else{
        if(this.$route.name==='ActivitiesBecomeCompany'){
          url = lang + this.$route.matched[0].path.match(/(?:\/)([^/]+)(?=#*)/g)[1]+this.$route.matched[0].path.match(/(?:\/)([^/]+)(?=#*)/g)[2]
        }
        window.location.href=window.location.origin+'/'+url
      }
    },
  },
};
</script>
<style lang="scss">
@import "style";
.lang-icon {
  width: 25px;
  height: 25px;
  border-radius: 100px;
  cursor: pointer;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}
.topbar {
  background-color: var(--projectPrimaryColor);
  border-radius: 20px;
  margin-top: 20px;
  padding: 1px 10px;
  .nav-link {
    color: white !important;
  }
  .languageDropDown{
      .dropdown-toggle {
        width: 234px;
        color: var(--projectPrimaryColor);
        background: $white;
        border-radius: var(--borderRadius);
        border: 1px solid var(--projectPrimaryColor);
        height: 40px;
        text-align: left;
        padding: 0 20px;
        &::after {
          content: unset;
        }
        &:active{
          color: var(--projectPrimaryColor) !important;
          background: $white;
          border-radius: var(--borderRadius);
          border: 1px solid var(--projectPrimaryColor) !important;
        }
        .chevron-down-icon {
          position: absolute;
          right: 20px;
          top: 8px;
        }
        .account-outline-icon {
          margin-right: 10px;
        }
        > span {
          > svg {
            width: 16px;
            height: 16px;
            margin-right: 15px;
            margin-top: -2px;
          }
        }
      }
      .dropdown-menu {
        > li {
          > .dropdown-item {
            padding: 10px 20px;
            color: #626262;
            font-size: 16px;
            @media (max-width: 992px) {
              font-size: 18px;
            }
            background: $white;
            white-space: unset;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: flex-start;
            -ms-flex-pack: flex-start;
            justify-content: flex-start;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            &:hover {
              background-color: #f8f9fa;
            }
            > span,
            svg {
              margin-right: 10px;
            }
            > svg {
              width: 16px;
              height: 16px;
              stroke: #626262;
            }
          }
        }
      }
      &.show {
        .dropdown-toggle {
          border-radius: 20px;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
        }
        .dropdown-menu {
          &.show {
            right: 0px;
            top: -10px !important;
            left: 0px;
            will-change: transform;
            border: 1px solid var(--projectPrimaryColor);
            border-top: 0;
            border-radius: 0;
          }
        }
      }
      .span-element {
        width: 100%;
          display: flex;
        // display: -webkit-box;
        // display: -ms-flexbox;
        // display: flex;
        // -webkit-box-pack: center;
        // -ms-flex-pack: center;
        // justify-content: space-between;
      }
      
      ul{
        min-width: 100px!important;
        left: 0!important;
      }
      .dropdown-toggle{
        width: 300px;
        @media (max-width: 992px){
          width: 100px!important;
        }
      }
      .dropdown-item{
        padding: 20px 20px!important;
        
      }
    }
}
.mobile-language-drop-down{
  .dropdown-menu.show{
    // min-width: 5rem;
  }
}
.active-website{
  border-bottom: 2px solid white;
  position: relative;
  box-shadow: 0px 3px 6px #6e6a6a29;
  &::after{
    content: '';
    width: 0;
    height: 0;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    border-bottom: 3px solid white;
    top: 85%;
    left: 43%;
    bottom: 0;
    right: 50%;
    position: absolute;
  }
}
</style>